import Vue from 'vue'
import template from './index.vue'

const UpdateConstructor = Vue.extend(template)

let updateInstance = null
let lastConstructor = null
let lastOptions = null

const Update = (options = null) => {
  const Handler = UpdateConstructor

  if (!updateInstance || lastConstructor !== Handler || (lastOptions && lastOptions.chatAvatar)) {
    updateInstance = new Handler({
      el: document.createElement('div')
    })
  }
  lastConstructor = Handler
  lastOptions = options
  Object.assign(updateInstance.$data, options || {}, {
    visible: true
  })
  return new Promise(resolve => {
    updateInstance.success = () => {
      resolve()
    }
    document.body.appendChild(updateInstance.$el)
  })
}

export default Update
